
function successInterceptor(response) {
    return response;
}

export {
    successInterceptor
}